module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Niclas_480x480.6853439b.mp4";